import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@zambezi/sdk/icons'
import { getHint, errorOptionsType, hintOptionsType } from './zambezi-helpers'

/**
 * @type {React.FunctionComponent<import('./interfaces').LabelProps>}
 * @param {import('./interfaces').LabelProps} props
 */
export default function Label ({
  inputOptions,
  label,
  children,
  hint,
  hintOptions = {},
  error,
  errorOptions = {}
}) {
  const errorIcon = error && errorOptions.showErrorInLabel
    ? <Icon
      name={errorOptions.iconName || 'error-small'}
      title={error}
      size={errorOptions.iconSize || 'xsmall'}
      className='zb-input-label-icon'
    />
    : null
  return (
    <span className='zb-input-label'>
      <label
        className='zb-input-label-name'
        id={inputOptions['aria-labelledby']}
        htmlFor={inputOptions.id || inputOptions.name}
      >
        {errorIcon}{children}
      </label>
      {getHint(hint, Object.assign({ label }, hintOptions))}
    </span>
  )
}

Label.propTypes = {
  inputOptions: PropTypes.shape({
    'aria-labelledby': PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  label: PropTypes.node,
  hint: PropTypes.node,
  hintOptions: hintOptionsType,
  error: PropTypes.string,
  errorOptions: errorOptionsType
}
